<template>
    <div>
        <v-container>
            <v-card-actions>
                <router-link to="/resources">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo 
            
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
                                                              
            </v-row>
            <v-row>                
                <v-col cols="12" md="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!---->                                                                                 
                    <details @click="mostrarAdjuntosCategories(2)" open>
                        <summary id="cat6">
                            <p><b>8.6. E-learning</b></p>
                        </summary>
                        <div class="pad-text">                           
                             <ul>
                               <li> 
                                <p>
                                <b>ICCS Course</b>:
                                    A self-administered course, aimed at learning how the International Classification of Crime for Statistical Purposes works, how it improves data consistency between and within countries, and understand the five main phases of ICCS implementation. In addition, the course shows how ICCS can improve the collection of crime data for the prevention and combating of transnational organized crime:
                                    <a href="https://elearningunodc.org/course/view.php?id=389" target="_blank">EN</a>                                     
                                    <br>
                                    </p>
                                </li>

                                <li>
                                  <p>
                                  <b>Advanced Diploma in Measurement of Gender Violence and Femicide</b>:
                                    Organized by CLACSO, ECLAC, UNDP and UN Women, this annual diploma includes lectures and discussion forums led by professionals and academics with extensive experience in the formulation and analysis of public policies and measurement of gender violence in Latin America and the Caribbean. The program addresses monitoring mechanisms and the production of data on violence against women, including those generated by civil society organizations:
                                    <a href="https://www.clacso.org/diploma-superior-en-medicion-de-violencia-por-razon-de-genero-contra-las-mujeres-y-de-femicidio-feminicidio-3/" target="_blank">ES</a>.
                                  </p>
                               </li>

                            <li>
                            <p>
                               <b>Regional training for measuring SDG 16</b>:
                                United Nations Office on Drugs and Crime (UNODC), the United Nations Development Programme (UNDP) and the Office of the United Nations High Commissioner for Human Rights (OHCHR) are organizing a series of training webinars focused on measuring progress on SDG 16 indicators in Latin America. The main objectives of this training are: Strengthen the technical capacities of authorities and coordination between data producers and users to generate, analyse and disseminate SDG 16 indicators; Strengthen the organizational framework and promote a "data community" among data producers and users for the exchange of experiences and challenges: 
                                <a href="https://www.cdeunodc.inegi.org.mx/unodc/index.php/home-mesurement-of-sdgs-reginonal-trining-for-measuring-sdg16-in-latin-america/index.htm" target="_blank">EN</a>.
                            </p>
                            </li>
                            </ul>
                        </div>
                    </details>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [],
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 8,
                    title: 'INTENTIONAL HOMICIDE',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+                            
                            '<li><a href="#cat1" style="text-decoration: none;">8.1. Homicide Data Sources</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat1_1" style="text-decoration: none;">8.1.1. UNODC Data Portal</a></li>'+
                                    '<li><a href="#cat1_2" style="text-decoration: none;">8.1.2. PAHO Homicide mortality webpage</a></li>'+  
                                    '<li><a href="#cat1_3" style="text-decoration: none;">8.1.3. WHO Global Health Observatory</a></li>'+                                    
                                '</ul>'+
                            '<li><a href="#cat2" style="text-decoration: none;">8.2. Homicides in Latin America and the Caribbean</a></li>'+                            
                            '<ul>'+
                                    '<li><a href="#cat2_1" style="text-decoration: none;">8.2.1 Key Drivers and Risk Factors of Homicidal Violence</a></li>'+
                                    '<ul>'+
                                        '<li><a href="#cat2_1_1" style="text-decoration: none;">8.2.1.1. Organized Crime, Gang Violence and Criminal Fragmentation</a></li>'+
                                        '<li><a href="#cat2_1_2" style="text-decoration: none;">8.2.1.2. Urbanization and increased social inequality</a></li>'+
                                        '<li><a href="#cat2_1_3" style="text-decoration: none;">8.2.1.3. Firearms Proliferation and Illicit Trade</a></li>'+
                                        '<li><a href="#cat2_1_4" style="text-decoration: none;">8.2.1.4. Youth and Gender Dimensions</a></li>'+
                                        '<li><a href="#cat2_1_5" style="text-decoration: none;">8.2.1.5. Drug Production and Trafficking</a></li>'+
                                        '<li><a href="#cat2_1_6" style="text-decoration: none;">8.2.1.6. Weak Justice Systems</a></li>'+
                                    '</ul>'+
                                    '<li><a href="#cat2_2" style="text-decoration: none;">8.2.2. Trends and Variations</a></li>'+  
                                     '<ul>'+
                                        '<li><a href="#cat2_2_1" style="text-decoration: none;">8.2.2.1. Subregional data</a></li>'+
                                        '<li><a href="#cat2_2_2" style="text-decoration: none;">8.2.2.2. Vulnerable Populations</a></li>'+  
                                        '<li><a href="#cat2_2_3" style="text-decoration: none;">8.2.2.3. Gender-based killings</a></li>'+ 
                                        '<li><a href="#cat2_2_4" style="text-decoration: none;">8.2.2.4. Killings of children and adolescents</a></li>'+                                    
                                    '</ul>'+
                                    '<li><a href="#cat2_3" style="text-decoration: none;">8.2.3 State of Emergency, UN Position and Lines of Engagement</a></li>'+      
                                    '<ul>'+
                                        '<li><a href="#cat2_3_1" style="text-decoration: none;">8.2.3.1. Escalating Use of Emergency Powers</a></li>'+
                                        '<li><a href="#cat2_3_2" style="text-decoration: none;">8.2.3.2. UN Concerns and Policy Position</a></li>'+  
                                        '<li><a href="#cat2_3_3" style="text-decoration: none;">8.2.3.3. Lines of UN Engagement</a></li>'+                                                                         
                                    '</ul>'+                               
                                '</ul>'+
                            '<li><a href="#cat3" style="text-decoration: none;">8.3. United Nations and regional standards, frameworks, and policies for addressing homicides and violent crimes</a></li>'+  
                              '<ul>'+
                                    '<li><a href="#cat3_1" style="text-decoration: none;">8.3.1. Global</a></li>'+
                                    '<li><a href="#cat3_2" style="text-decoration: none;">8.3.2. Regional</a></li>'+                                                                        
                                '</ul>'+  
                            '<li><a href="#cat4" style="text-decoration: none;">8.4. Key dimensions to address homicides in LAC</a></li>'+    
                            '<ul>'+
                                    '<li><a href="#cat4_1" style="text-decoration: none;">8.4.1. Targeting Organized Crime and Firearms Control</a></li>'+
                                    '<li><a href="#cat4_2" style="text-decoration: none;">8.4.2. Strengthening the Rule of Law and Justice Systems</a></li>'+ 
                                    '<li><a href="#cat4_3" style="text-decoration: none;">8.4.3. Prevention Through Social Development</a></li>'+ 
                                    '<li><a href="#cat4_4" style="text-decoration: none;">8.4.4. Urban Security and Evidence-Based Policing</a></li>'+ 
                                    '<li><a href="#cat4_5" style="text-decoration: none;">8.4.5. Support to survivors and victims of violence and their communities, as well as Violence Prevention Services</a></li>'+ 
                                    '<li><a href="#cat4_6" style="text-decoration: none;">8.4.6. Political Commitment and Governance</a></li>'+ 
                                    '<li><a href="#cat4_7" style="text-decoration: none;">8.4.7. Monitoring, Data, and Research</a></li>'+ 
                                '</ul>'+ 
                            '<li><a href="#cat5" style="text-decoration: none;">8.5. Mandates and key services of UN agencies, programmes and funds</a></li>'+   
                             '<ul>'+
                                    '<li><a href="#cat5_1" style="text-decoration: none;">8.5.1. UNODC – United Nations Office on Drugs and Crime</a></li>'+
                                    '<li><a href="#cat5_2" style="text-decoration: none;">8.5.2. UNDP – United Nations Development Programme</a></li>'+ 
                                    '<li><a href="#cat5_3" style="text-decoration: none;">8.5.3. PAHO/WHO – Pan American Health Organization / World Health Organization</a></li>'+ 
                                    '<li><a href="#cat5_4" style="text-decoration: none;">8.5.4. UNICEF – United Nations Children’s Fund</a></li>'+ 
                                    '<li><a href="#cat5_5" style="text-decoration: none;">8.5.5. UN Women</a></li>'+ 
                                    '<li><a href="#cat5_6" style="text-decoration: none;">8.5.6. UNESCO – United Nations Educational, Scientific and Cultural Organization</a></li>'+ 
                                    '<li><a href="#cat5_7" style="text-decoration: none;">8.5.7. ILO – International Labour Organization</a></li>'+ 
                                    '<li><a href="#cat5_8" style="text-decoration: none;">8.5.8. World Bank</a></li>'+ 
                                    '<li><a href="#cat5_9" style="text-decoration: none;">8.5.9. ECLAC – Economic Commission for Latin America and the Caribbean</a></li>'+ 
                                    '<li><a href="#cat5_10" style="text-decoration: none;">8.5.10. OHCHR – Office of the High Commissioner for Human Rights</a></li>'+                                                                        
                                '</ul>'+  

                            '<li><a href="#cat6" style="text-decoration: none;">E-learning</a></li>'+    
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: 'Latin American and Caribbean (LAC) countries are not immune to terrorism. Recent evidence indicates that criminal organizations may be adopting tactics similar to those associated with terrorist organizations and that new trends and cells inspired by violent extremism conducive to terrorism have surfaced in the region.'+
                    '<br><br>The connection between terrorism and criminal activities has grown stronger, more effective, and more prevalent in certain parts of the Americas. States have recognized the threat posed by terrorism and have gradually introduced measures to prevent terrorist acts and the movement of terrorists across borders.'+
                    '<br><br>More needs to be done especially regarding emerging terrorist threats, whether on critical infrastructure, environmental terrorism, new forms of violent extremism, financing of terrorism, nuclear terrorism and addressing the nexus between terrorism and transnational organized crime in the LAC region and its impact around the world.',
                    description: '',                    
                    images: ['8.jpg'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarTerrorism/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarHomicides/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte9/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte8/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategoriesHomicides/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                return []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        
        /*
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }    
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }
    /* Justificar texto*/
    .wrap-text {
    text-align: justify;        
    }
    /* Ajustar el ancho del texto para que no se salga del contenedor */
    .pad-text {
        padding-left: 0.50rem; 
        padding-right: 0.50rem;
        
    }
    /* Altura de tu encabezado + margen de seguridad */
    html {
        scroll-padding-top: 50px;   
    }

    [id^="cat"] {                /* Todos los ids que empiezan por "cat" */
        scroll-margin-top: 50px;   
    }

    /* What You’ll Find Inside */
 /* Typography mejorada */
    .page-title {
    font-size: 2.5rem;
    color: #1a237e;
    font-weight: 600;
    margin-bottom: 1.5rem;
    font-family: 'Heebo', sans-serif;
    letter-spacing: -0.5px;
    }

    /* Contenedor interior mejorado */
    .inside-container {
    position: relative;           /* Para que el título absoluto se ancle aquí */
    border: 4px solid #0E87C9;
    border-radius: 12px;
    padding: 2.5rem 1.5rem 0.5rem; /* +padding-top para no tapar el h3 */
    background-color: #fff;
    max-width: 98%;
    margin: 0 auto;
    }

    /* Título superpuesto */
    .inside-title {
    position: absolute;
    top: -1.4rem;          /* Altura negativa = por encima del borde */
    left: 1.2rem;        /* Alinearlo con el texto interior */
    background-color: #0E87C9;
    color: #fff;
    padding: 0.6rem 0.75rem;
    font-size: 1.25rem;
    border-radius: 6px;
    white-space: nowrap; /* Evita que se rompa en dos líneas */
    margin: 0;           /* Elimina márgenes por defecto */
    }

    /* Lista y checks */
    .inside-list {
    list-style: none;
    padding: 0;
    margin: 0;
    }

    .inside-list li {
    position: relative;
    padding-left: 2.4rem;
    margin-bottom: 0.8rem;
    line-height: 1.05;
    }

    .inside-list li::before {
    content: "✔";
    position: absolute;
    left: 0;
    top: 0.15rem;
    color: #0E87C9;
    font-size: 1.1rem;
    }
    

</style>